import { Button, Col, Form, Row } from "react-bootstrap"
import BihamtaTable from "../../../Components/BihamtaTable"
import DatePicker from "react-datepicker2";
import { searchCallHistory } from "../../store/api/CustomerApi";
import { useRef, useState } from "react";
import { Search } from "react-bootstrap-icons";


const CustomerCallHistory = (props) => {
    const { customerID, callerType } = props;
    const [dataList, setDataList] = useState({ Data: [] });
    const searchData = useRef({});
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "کاربر داخلی", colName: "UserName" },
        { colTitle: "شماره تماس", colName: "CallNumber" },
        { colTitle: "تاریخ و ساعت تماس", colName: "PCallDate" }
    ]
    function search(e) {
        if (e?.key && e.key !== "Enter") {
            return;
        }
        const pCallDate = document.getElementsByName("CallDate")[0];
        if (pCallDate.value === "") {
            searchData.current.CallDate = null;
        }
        const pToDate = document.getElementsByName("ToDate")[0];
        if (pToDate.value === "") {
            searchData.current.ToDate = null;
        }
        searchData.current.CustomerID = customerID;
        searchData.current.CallerType = callerType;
        searchCallHistory(searchData.current, setDataList);
    }
    return (
        <Row>
            <Row className="rowBorder">
                <Col md={2} className="form-group">
                    <label>از تاریخ: </label>
                    <DatePicker isGregorian={false} timePicker={false} className="form-control" name='CallDate'
                        onChange={value => { searchData.current.CallDate = value.local("en").format("YYYY-MM-DD") }} />
                </Col>
                <Col md={2} className="form-group">
                    <label>تا تاریخ: </label>
                    <DatePicker isGregorian={false} timePicker={false} className="form-control" name='ToDate'
                        onChange={value => { searchData.current.ToDate = value.local("en").format("YYYY-MM-DD") }} />
                </Col>
                <Col md={2} className="form-group">
                    <label>شماره تماس: </label>
                    <Form.Control onChange={e => searchData.current.CallNumber = e.target.value} onKeyDown={search} />
                </Col>
                <Col md={2} className="form-group">
                    <label>نام تماس گیرنده: </label>
                    <Form.Control onChange={e => searchData.current.CallerName = e.target.value} onKeyDown={search} />
                </Col>
                <Col md={2} className="form-group">
                    <label>کاربر داخلی: </label>
                    <Form.Control onChange={e => searchData.current.UserName = e.target.value} onKeyDown={search} />
                </Col>
                <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "1px" }}>
                    <Button className="group-Btn-large" variant="secondary" onClick={search}><Search size={18} />&nbsp; جستجوی تماس&nbsp;</Button>
                </Col>
            </Row>
            <BihamtaTable columns={tableCols} dataList={dataList} maxHeight={500} className="mt-0" />
        </Row>
    )
}
export default CustomerCallHistory;
